module.exports = __webpack_public_path__ + "img/itx-text-h2.69ec9beb.svg";